module.exports = __webpack_public_path__ + "media/fonts/Oricons-709fec0be91bbe0ff7bc98b0d19ffb15.svg";